const devices = ["smartphone", "laptop", "tablet"];
const isADeviceCheck = (d) => devices.includes(d) || d === "devices";

export default isADeviceCheck